<template>
  <div class="form right">
    <el-dialog title="Departamento" :append-to-body="true" center :visible.sync="dialog">
      <el-form>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <DepartmentChat v-model="department" :current="department" />
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click.stop.prevent="dialog = false">Cancelar</el-button>
        <el-button type="primary" @click.stop.prevent="transfer">Transferir</el-button>
      </span>
    </el-dialog>
    <el-input ref="chatText" :disabled="disabled" class="form__input" type="text" placeholder="Digite a sua mensagem..."
      v-model="msg" @keyup.enter.native="submitMessage">
      <el-button @click="submitMessage" style="background-color: #fff; color: #22418d" slot="append"><i
          class="fa fa-chevron-circle-right fa-2x el-input__icon"></i></el-button>
    </el-input> <br /><br />
    <el-row>
      <el-col>
        <el-button v-show="state === 'operator'" size="mini" type="text" @click="$emit('home')">Voltar</el-button>
        <el-button :disabled="disabled" v-show="state === 'operator'" size="mini" type="default" plain
          @click="dialog = true">Transferir</el-button>
        <el-button :disabled="disabled" class="right" size="mini" type="danger" @click="close">Encerrar
          Chat</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import DepartmentChat from '@/xpost/views/register/department/DepartmentChat'
export default {
  props: ["disabled", 'state'],
  components: {
    DepartmentChat,
  },
  data() {
    return {
      msg: "",
      dialog: false,
      department: ''
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    transfer() {
      if (!this.department) {
        return this.$message({
          type: "error",
          message: "Informe o departamento para transferir!",
        });
      }
      this.dialog = false;
      this.$emit("transfer", this.department);
    },
    submitMessage() {
      const vm = this;
      if (vm.msg) {
        vm.$emit("chat", this.msg);
        vm.msg = "";
        vm.$refs.chatText.$el.children[0].focus();
      }
      return;
    },
  },
};
</script>

<style scoped>
.form {
  margin-top: 20px;
  justify-content: space-between;
  padding: 0.4rem;
  border-radius: 30px 30px 24px 24px;
  box-shadow: 0px -5px 30px rgba(0, 0, 0, 0.05);
}


.form__submit {
  align-items: center;
  cursor: pointer;
}
